module.exports = __webpack_public_path__ + "static/video_poster.652c51e6.jpg";